import React from 'react';
import { Text } from '@perch-labs/shrike';
import { Container } from 'styles';
import { copyFor } from 'config';
import { Numeral } from 'pages/billing/components/billing-explainer/billing-explainer.style';

const getCopy = copyFor('billing.billingExplainer.dualBilling');

export const DualBilling = (): JSX.Element => {
  const steps = getCopy('steps');
  const preStepText = getCopy('preStepText');
  const postStepParagraphs = getCopy('postStepParagraphs');
  return (
    <>
      <Text>{preStepText}</Text>
      {steps.map((text, index) => (
        <Container flex direction="row" margin={{ top: '24px' }} key={text}>
          <Numeral>
            <Text textStyle="heading400">{index + 1}</Text>
          </Numeral>
          <Text margin={{ left: '16px', top: '0', bottom: '0' }}>{text}</Text>
        </Container>
      ))}
      {postStepParagraphs.map((text, index) => (
        <Container
          flex
          margin={{ top: index === 0 ? '24px' : '16px' }}
          key={text}
        >
          <Text>{text}</Text>
        </Container>
      ))}
    </>
  );
};
